import { Cdr, Cdrs } from "./cdrs";
import {
  CommandResponse,
  ReserveNowCommand,
  StartSessionCommand,
  StopSessionCommand,
  UnlockConnectorCommand,
} from "./commands";
import { OcpiCredentials } from "./credentials";
import { Connector, Evse, Location, Locations } from "./locations";
import { Session, Sessions } from "./sessions";
import { Tariff, Tariffs } from "./tariffs";
import { AuthorizationInfo, Token, Tokens } from "./tokens";
import { OcpiVersionDetails, OcpiVersions } from "./versions";

export const OcpiSchemas = {
  versions: OcpiVersions,
  versionDetails: OcpiVersionDetails,
  credentials: OcpiCredentials,
  location: Location,
  locations: Locations,
  evse: Evse,
  connector: Connector,
  session: Session,
  sessions: Sessions,
  cdr: Cdr,
  cdrs: Cdrs,
  tariff: Tariff,
  tariffs: Tariffs,
  token: Token,
  tokens: Tokens,
  authorizationInfo: AuthorizationInfo,
  commandResponse: CommandResponse,
  reserveNow: ReserveNowCommand,
  startSession: StartSessionCommand,
  stopSession: StopSessionCommand,
  unlockConnector: UnlockConnectorCommand,
};
